import { translate } from "app/filters/i18nFilter";

export const getOpenText = () => translate("global.open");
export const getSaveText = () => translate("global.save");
